export default "__VITE_ASSET__DKARMv9K__"